import { render, staticRenderFns } from "./AchievementNotice.vue?vue&type=template&id=f03a5240&scoped=true&"
import script from "./AchievementNotice.vue?vue&type=script&lang=js&"
export * from "./AchievementNotice.vue?vue&type=script&lang=js&"
import style0 from "./AchievementNotice.vue?vue&type=style&index=0&id=f03a5240&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f03a5240",
  null
  
)

export default component.exports